/* Consent-gated analytics. Firebase Analytics is loaded lazily and only
   when (a) the visitor accepted consent and (b) a measurement ID is
   configured. No measurement ID → analytics is simply absent (no error),
   so the site runs fine without it. */
import { app } from './firebase.js'

let started = false

export async function startAnalytics() {
  if (started) return
  const hasId = !!import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
  if (!hasId) return // analytics not configured — skip silently
  started = true
  try {
    const { getAnalytics, isSupported } = await import('firebase/analytics')
    if (await isSupported()) getAnalytics(app)
  } catch {
    started = false // allow a later retry
  }
}
